import React, { useEffect, useState } from "react";
import { Tooltip, Card, Descriptions } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

function Summary({ equipmentData }) {
  const [summaryData, setSummaryData] = useState([]);

  //summary is a count for each category of equipment where the Condition is 'Working' and Status is 'In Use'
  useEffect(() => {
    const summary = equipmentData.reduce((acc, curr) => {
      if (curr.condition === "Working" && curr.status === "In Use") {
        const category = curr.equipment.category;
        acc[category] = acc[category] ? acc[category] + 1 : 1;
      }
      return acc;
    }, {});

    const sortedSummary = Object.entries(summary).sort((a, b) => b[1] - a[1]);
    const orderedSummary = Object.fromEntries(sortedSummary);
    setSummaryData(orderedSummary);
  }, [equipmentData]);

  return (
    <Card
      title={
        <div className="flex justify-between items-center">
          <span>Equipment Summary</span>
          <Tooltip title="This includes only equipment that's 'In Use' and 'Working'">
            <InfoCircleOutlined />
          </Tooltip>
        </div>
      }
      bordered
      bodyStyle={{ padding: 0 }}
    >
      <Descriptions column={1} bordered>
        {Object.entries(summaryData).map(([category, count]) => (
          <Descriptions.Item key={category} label={category}>
            {count}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </Card>
  );
}

export default Summary;
